<template>
    <Button :loading="loading" @click="scan">
        <div class="flex items-center space-x-1">
            <Icon icon="hero/outline/qrcode" class="w-5 h-5" />
            <p class="text-xs">Naskenovat</p>
        </div>
    </Button>
    <div
        v-if="isScanning"
        ref="scannerWrapper"
        class="fixed top-0 bottom-0 left-0 right-0 z-50 flex flex-col items-center justify-center bg-black/25"
        @click="close"
    >
        <Loading :loading="true" size="xl" class="text-white" />
    </div>
</template>
<script setup lang="ts">
import { nextTick, ref, toRef } from 'vue';
import { Html5Qrcode } from 'html5-qrcode';

interface Props {
    loading?: boolean;
}

const emit = defineEmits(['scanned']);

const props = withDefaults(defineProps<Props>(), {
    loading: false,
});

const loading = toRef(props, 'loading');
const isScanning = ref(false);
const scannerWrapper = ref(null);
const scanner = ref(null);

const scan = () => {
    isScanning.value = true;
    Html5Qrcode.getCameras()
        .then((devices) => {
            if (devices && devices.length) {
                const id = (Math.random() + 1).toString(36).substring(7);

                nextTick(() => {
                    scannerWrapper.value.innerHTML = `
                        <div id="${id}" class="w-4/5 h-4/5">
                        </div>
                    `;
                    const cameraId = devices[0].id;
                    scanner.value = new Html5Qrcode(id);
                    scanner.value.start(
                        cameraId,
                        {
                            fps: 10,
                            qrbox: { width: 250, height: 250 },
                        },
                        (decodedText, decodedResult) => {
                            emit('scanned', { text: decodedText, data: decodedResult });
                            close();
                        },
                        () => {
                            // console.log(errorMessage);
                        },
                    );
                });
            }
        })
        .catch((err) => {
            console.log(err);
        });
};

const close = () => {
    scanner.value.stop();
    isScanning.value = false;
};
</script>
